import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChargeService } from 'app/core/services/charge.service';
import { RefreshChargeService } from 'app/core/services/refresh-charge/refresh-charge.service';

@Component({
  selector: 'dialog-delete-charge',
  templateUrl: './dialog-delete-charge.component.html',
  styleUrls: ['./dialog-delete-charge.component.scss']
})
export class DialogDeleteChargeComponent implements OnInit {

  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogDeleteChargeComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private chargeService: ChargeService,
    private refreshChargeService: RefreshChargeService) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteCharge() {
    this.isLoading = true;
    this.chargeService.deleteCharge(this.data.id).subscribe({
      next: (res) => {
        this.refreshChargeService.emitRefresh(this.data.index);
        this.isLoading = false;
        this.dialogRef.close();
      },
      error: (err) => {
        this.isLoading = true;
        console.error('Error deleting category:', err);
      },
    });
  }

}
